//export const BASE_URL='http://localhost:55602/srtestapi';
export const BASE_URL='https://mocktestapi.shubhraviraj.in/srtestapi';
export const AuthToken='HYDH22146khkja32@5SRdadhkTGE##2o35';
